export default __webpack_public_path__ + "static/media/our-services-home-care-reablement-services.02e41e2e.jpg";